import { httpService } from "./httpService";

/**
 * Tenant branding / whitelabel settings.
 * Backend: fleetmd-backend TenantBrandingController.
 */

export const getTenantBranding = async () =>
  httpService({
    url: "/tenant/whitelabel",
    options: { method: "GET" },
  });

/**
 * @param {{
 *   orgName?: string, logoUrl?: string,
 *   primaryColor?: string, accentColor?: string,
 *   contactEmail?: string, supportPhone?: string, dispatchPhone?: string,
 *   termsUrl?: string, privacyUrl?: string,
 *   auditPacketFooter?: string,
 * }} payload
 */
export const saveTenantBranding = async (payload) =>
  httpService({
    url: "/tenant/whitelabel",
    options: { method: "PUT", data: payload },
  });
